import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Checkbox } from '../../../../../../../common/html/checkbox'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../../../helpers/EventEmitter'
import { MAX_SELECTED_COMPANY } from '../../../../constants'
import { changeSelectedCompanyList } from '../../store/slice'

export const FirstColumnCell = ({
  val,
  selectedCompanyList,
  data,
  typeSelect,
}) => {
  const dispatch = useDispatch()

  const allSelectionIds = data?.map((item) => item.organizationId)
  const selectedCompanyIds = selectedCompanyList.map((item) => item.id)
  const isChecked =
    selectedCompanyList.length > 0 &&
    (typeSelect === 'selectOne'
      ? selectedCompanyIds.some((item) => item === val)
      : allSelectionIds.every((item) => selectedCompanyIds.includes(item)))
  const onchangeCheckBoxItem = (val) => {
    if (isChecked) {
      if (typeSelect === 'selectOne') {
        const newSelectedCompanyList = selectedCompanyList.filter(
          (item) => item.id !== val,
        )
        dispatch(changeSelectedCompanyList(newSelectedCompanyList))
      } else {
        const newSelectedCompanyList = selectedCompanyList.filter(
          (item) => !allSelectionIds.includes(item.id),
        )
        dispatch(changeSelectedCompanyList(newSelectedCompanyList))
      }
    } else {
      if (selectedCompanyList.length >= MAX_SELECTED_COMPANY) {
        EventEmitter.dispatch(SHOW_POPUP_ERROR, {
          messages: [
            <Translate
              value={'companyAnalysis.peerAnalysis.OVER_SELECTION_POPUP_TEXT'}
            />,
          ],
        })
        return
      }

      if (typeSelect === 'selectOne') {
        const newSelection = data.find((item) => item.organizationId === val)
        dispatch(
          changeSelectedCompanyList([
            ...selectedCompanyList,
            { id: val, name: newSelection.organizationName },
          ]),
        )
      } else {
        if (selectedCompanyList.length + data.length > MAX_SELECTED_COMPANY) {
          EventEmitter.dispatch(SHOW_POPUP_ERROR, {
            messages: [
              <Translate
                value={'companyAnalysis.peerAnalysis.OVER_SELECTION_POPUP_TEXT'}
              />,
            ],
          })
          return
        }

        const allSelection = data.map((item) => {
          return { id: item.organizationId, name: item.organizationName }
        })
        const newSelectedCompanyList = [...selectedCompanyList, ...allSelection]
        const uniqueSelection = Array.from(
          new Set(newSelectedCompanyList.map((a) => a.id)),
        ).map((id) => {
          return newSelectedCompanyList.find((a) => a.id === id)
        })
        dispatch(changeSelectedCompanyList(uniqueSelection))
      }
    }
  }

  return (
    <div className="dFlex alignItemsCenter">
      <Checkbox
        value={val}
        checked={isChecked}
        onChange={() => onchangeCheckBoxItem(val)}
      />
    </div>
  )
}
